require('./promo-codes-new-container.scss')

module.exports = {
  template: require('./promo-codes-new-container.pug')()
  controller: require('./promo-codes-new-container.ctrl')
}
